<template>
  <tbody>
    <tr>
      <template v-if="dynalabelItem.loading">
        <td :colspan="numColumns">
          <v-skeleton-loader
            class="insight-data-tile"
            type="image"
            max-height="10"
          ></v-skeleton-loader>
        </td>
      </template>
      <template v-else>
        <td style="white-space: nowrap; width: 200px;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <expand-dyna-label-row
                v-if="dynalabelItem.hasOwnProperty('teams')"
                :dynalabelItem="dynalabelItem"
                :toggleDisabled="dynalabelDisabled(dynalabelItem)"
                @toggleDynaExpand="
                  toggleRow(dynalabelItem, !dynalabelItem.expanded)
                "
              ></expand-dyna-label-row>

              <v-btn
                v-bind="attrs"
                v-on="on"
                :disabled="dynalabelDisabled(dynalabelItem)"
                @click="loadDynalabelDetails(dynalabelItem.id)"
                text
                small
                class="agent-btn"
                color="primary"
                >{{ dynalabelItem.name }}
              </v-btn>
            </template>
            <span
              >{{ dynalabelItem.name }} ({{ dynalabelItem.id }}) dynamic
              label&hellip;</span
            >
          </v-tooltip>
        </td>

        <td class="text-center">
          <span v-if="dynalabelItem.call_count > 0">{{
            dynalabelItem.average_handle_time
          }}</span>
        </td>

        <td class="text-center">
          <span v-if="dynalabelItem.call_count > 0">{{
            dynalabelItem.average_call_volume
          }}</span>
        </td>
        <td class="text-center">
          <span v-if="dynalabelItem.call_count > 0">{{
            dynalabelItem.call_count
          }}</span>
        </td>
        <td class="text-center">
          <score-chip
            v-if="dynalabelItem.call_count > 0"
            :score="dynalabelItem.average_call_score"
            :calls_modified="dynalabelItem.calls_modified"
            :aggregate_cat="false"
          ></score-chip>
        </td>

        <td
          v-for="(slot, i) in filteredColumnSlots"
          :key="slot.id"
          class="text-center"
        >
          <scorecards-category-display v-if="showScoreChip(slot)" 
            :key="i"
            :infoItem="dynalabelItem" 
            :infoSlot="slot"
            :nonAppCatHandling="nonAppCatHandling"
          ></scorecards-category-display>
        </td>
      </template>
    </tr>

    <tr v-if="dynalabelItem.expanded && !dynalabelItem.loading">
      <td :colspan="numColumns" style="padding:0;">
        <dyna-label-row-teams
          :dynalabelItem="dynalabelItem"
          :durationValHeaderText="durationValHeaderText"
          :aggregateRow="aggregateRow"
          :nonAppCatHandling="nonAppCatHandling"
        ></dyna-label-row-teams>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ScoreChip from "@/components/Scorecards/ScoreChip.vue";
import moment from "moment";
import presentation from "@/mixins/presentation";
import ExpandDynaLabelRow from "./ExpandDynaLabelRow.vue";
import DynaLabelRowTeams from "./DynaLabelRowTeams.vue";
import SubjectiveDistributionWidget from '../../Widgets/SubjectiveDistributionWidget.vue';
import ScorecardsCategoryDisplay from './ScorecardsCategoryDisplay.vue';

const DATA_COLUMN_LENGTH = 5;
const ROUTE_NAME = "scorecards-v2-dynalabels";
const REQUEST_LIMIT = 8;

export default {
  components: { ScoreChip, ExpandDynaLabelRow, DynaLabelRowTeams, SubjectiveDistributionWidget, ScorecardsCategoryDisplay },
  mixins: [presentation],
  props: {
    dynalabelItem: {
      type: Object,
      required: true
    },
    columnSlots: {
      type: Array,
      required: true
    },
    nonAppCatHandling: {
      type: Number,
      required: true
    },
    durationValHeaderText: {
      type: String,
      required: true
    },
    aggregateRow: {
      type: Boolean,
      default: false
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    collapseAll: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    ...mapGetters("dateRange", ["start_date", "end_date"]),
    ...mapGetters("scorecardsV2", [
      "categorySkeletonData",
      "categorySkeletonDataLoadingStatus",
      "categorySkeletonDataLoadingError",
      "categorySkeletonDataLoadingErrorStatus"
    ]),
    ...mapGetters("scorecardsV2Aggregates", [
      "groupedScorecardDynalabelData",
      "groupedScorecardDynalabelDataLoadingStatus",
      "groupedScorecardDynalabelDataLoadingError",
      "groupedScorecardDynalabelDataLoadingErrorStatus",

      "displayFormats",
      "dynaRequestCount",

      "dynaTeamRowsLoaded"
    ]),
    filteredColumnSlots() {
      return this.aggregateRow
        ? this.columnSlots
        : this.columnSlots[this.dynalabelItem.id];
    },
    numColumns() {
      return DATA_COLUMN_LENGTH + this.categorySkeletonData.length;
    },
    getUnit() {
      return moment(this.end_date).diff(moment(this.start_date), "days") > 1
        ? "day"
        : "hour";
    }
  },
  methods: {
    ...mapActions({
      retrieveDynalabelTeamRow:
        "scorecardsV2Aggregates/retrieveDynalabelTeamRow",
      addToDynaRequestCount: "scorecardsV2Aggregates/addToDynaRequestCount",
      setDynaLabelExpand: "scorecardsV2Aggregates/setDynaLabelExpand",
      pushDynaTeamReqId: "scorecardsV2Aggregates/pushDynaTeamReqId",
      setDynaLabelAggExpand: "scorecardsV2Aggregates/setDynaLabelAggExpand"
    }),
    showScoreChip(slot) {
      return this.aggregateRow
        ? this.dynalabelItem.call_count > 0
        : this.dynalabelItem.call_count > 0 &&
            this.dynalabelItem.id == slot.item_id;
    },
    toggleRow(item, expanded) {
      if (this.aggregateRow) {
        this.setDynaLabelAggExpand({
          id: item.id,
          expanded: expanded
        });
      } else {
        this.setDynaLabelExpand({
          id: item.id,
          expanded: expanded
        });
      }

      if (expanded) {
        this.initiateDynaTeamRetrieve(item);
      }
    },
    initiateDynaTeamRetrieve(dynaItem) {
      let teamIdsToLoad = [];
      for (const team of dynaItem.teams) {
        let dynaTeamId = dynaItem.id + "_" + team.team_id;
        if (this.canLoadDynaTeam(team, dynaTeamId)) {
          teamIdsToLoad.push(team.team_id);
          this.pushDynaTeamReqId(dynaTeamId);
        }
      }

      if (teamIdsToLoad.length > 0) {
        this.sendDynaTeamRowRequest(teamIdsToLoad, dynaItem.id);
      }
    },
    dynalabelDisabled(item) {
      return item.call_count < 1 && item.excluded_calls < 1 ? true : false;
    },
    loadDynalabelDetails(dynaId) {
      if (this.aggregateRow) {
        this.loadDynaLabelTeam();
      } else {
        this.loadDynaLabelAgents(dynaId);
      }
    },
    loadDynaLabelTeam() {
      this.$router
        .push({
          path:
            "/scorecards-v2/" +
            this.$route.params.scorecardId +
            "/dynalabels/0/agents/",
          query: this.$route.query
        })
        .catch(err => {});
      setTimeout(function() {
        if (this.$vuetify) this.$vuetify.goTo(0);
      }, 1500);
    },
    loadDynaLabelAgents(dynaId) {
      this.$router
        .push({
          path:
            "/scorecards-v2/" +
            this.$route.params.scorecardId +
            "/dynalabels/" +
            dynaId +
            "/agents/",
          query: this.$route.query
        })
        .catch(err => {});
      setTimeout(function() {
        if (this.$vuetify) this.$vuetify.goTo(0);
      }, 1500);
    },
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    canLoadDynaTeam(team, dynaTeamKey) {
      return (
        this.dynaRequestCount < REQUEST_LIMIT &&
        !this.dynaTeamRowsLoaded.includes(dynaTeamKey) &&
        !team.loaded
      );
    },
    sendDynaTeamRowRequest(teamIdsToLoad, dynaRowId) {
      if (this.$route.name == ROUTE_NAME) {
        this.addToDynaRequestCount(2);
        this.retrieveDynalabelTeamRow({
          scorecard_id: this.$route.params.scorecardId,
          dynalabel_id: this.dynalabelItem.id,
          start_date: moment(this.start_date).format("YYYY-MM-DD"),
          end_date: moment(this.end_date).format("YYYY-MM-DD"),
          grouping: this.getUnit,
          call_type:
            this.$store.getters["filters/scorecardAdjustments"] || "all",
          team_ids: teamIdsToLoad,
          dyna_row_id: dynaRowId,
          aggregate_row: this.aggregateRow
        });
      }
    },
    loadDynaTeamRows() {
   
      if (
        this.$route.name == ROUTE_NAME &&
        !this.groupedScorecardDynalabelDataLoadingErrorStatus
      ) {
        let teamIdsToLoad = [];
        if (this.dynalabelItem.expanded) {
          for (const team of this.dynalabelItem.teams) {
            let dynaTeamId = this.dynalabelItem.id + "_" + team.team_id;
            if (this.canLoadDynaTeam(team, dynaTeamId)) {
              teamIdsToLoad.push(team.team_id);
              this.pushDynaTeamReqId(dynaTeamId);
            }
          }
          if (teamIdsToLoad.length > 0) {
            this.sendDynaTeamRowRequest(teamIdsToLoad, this.dynalabelItem.id);
          }
        }
      }
    },
    expandAllDynas() {
      this.toggleRow(this.dynalabelItem, true);
    },
    collapseAllDynas() {
      this.toggleRow(this.dynalabelItem, false);
    }
  },
  mounted() {},
  watch: {
    dynaRequestCount: "loadDynaTeamRows",
    expandAll: "expandAllDynas",
    collapseAll: "collapseAllDynas"
  }
};
</script>

<style scoped>
::v-deep button.agent-btn span.v-btn__content {
  width: 200px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}
</style>
